<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Card Title</label>
            <input type="checkbox" v-model="fields.cardTitle.show" />
          </div>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.cardTitle.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Images</label>
          <div class="group-item">
            <v-row class="mb-4">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.wrapImages.maxWidth"
                  type="number"
                  label="Max width"
                  min="0"
                  suffix="px"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select v-model="fields.wrapImages.align" :items="alignOptions" label="Align" hide-details />
              </v-col>
            </v-row>
            <div class="mb-4">
              <label class="mb-2 d-block">Desktop Image</label>
              <UploadImage
                @callback="handleUploadDesktop"
                :image="{ imageSrc: fields.wrapImages.imageDesktop }"
                :height="`160`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveDesktop"
              />
            </div>

            <div class="d-flex align-center mb-2" style="gap: 10px">
              <label for="useMobileImage" class="mb-0">Use Mobile Image</label>
              <input
                id="useMobileImage"
                name="useMobileImage"
                type="checkbox"
                v-model="fields.wrapImages.useMobileImage"
              />
            </div>
            <div v-if="fields.wrapImages.useMobileImage" class="mb-4">
              <label class="mb-2 d-block">Mobile Image</label>
              <UploadImage
                @callback="handleUploadMobile"
                :image="{ imageSrc: fields.wrapImages.imageMobile }"
                :height="`160`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveMobile"
              />
            </div>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'card-fastvaluedeal-title-img-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      alignOptions: ['left', 'center', 'right'],
      fields: {
        title: 'Card FastValueDeal Title Img Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        cardTitle: {
          show: true,
          content: '<h2>Heading</h2><p>Description</p>',
        },
        wrapImages: {
          useMobileImage: true,
          maxWidth: 900,
          align: 'center',
          imageDesktop: '',
          imageMobile: '',
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        cardTitle: { ...this.fields.cardTitle, ...(extract.cardTitle || {}) },
        wrapImages: { ...this.fields.wrapImages, ...(extract.wrapImages || {}) },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardFastvaluedealTitleImg(
        this.sectionEditor.section.html,
        this.fields,
      );
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadDesktop(obj) {
      this.fields.wrapImages.imageDesktop = obj.imageSrc || '';
    },
    handleRemoveDesktop() {
      this.fields.wrapImages.imageDesktop = '';
    },
    handleUploadMobile(obj) {
      this.fields.wrapImages.imageMobile = obj.imageSrc || '';
    },
    handleRemoveMobile() {
      this.fields.wrapImages.imageMobile = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
